<template>
  <div class="consignment-details-container">
    <a-card :loading="loading" class="consignment-header-card">
      <div slot="title">
        Receive Consignment - {{ consignmentDetails.consignmentId || "N/A" }}
        <p style="font-size: 13px; color: #6b7280; margin-top: 10px">
          Confirm receipt of consignment stock, record any discrepancies, and
          log arrival details.
        </p>
      </div>
      <div slot="extra">
        <a-button
          type="primary"
          style="
            background-color: #26a246;
            color: white;
            border: 1px solid #26a246;
          "
          >Export Summary Report</a-button
        >
      </div>
      <a-row :gutter="16" style="margin-bottom: 10px">
        <a-col :span="4">
          <div style="display: flex; flex-direction: column">
            <span style="font-size: 15px; color: #6b7280; font-weight: 500"
              >Consignment ID</span
            >
            <span style="font-size: 14px; color: #222; font-weight: 600">{{
              consignmentDetails.consignmentId || "N/A"
            }}</span>
          </div>
        </a-col>
        <a-col :span="4">
          <div
            style="
              display: flex;
              flex-direction: column;
              align-items: flex-start;
            "
          >
            <span style="font-size: 15px; color: #6b7280; font-weight: 500"
              >Status</span>
            <StatusTag :status="consignmentDetails.status" />
          </div>
        </a-col>
        <a-col :span="5">
          <div style="display: flex; flex-direction: column">
            <span style="font-size: 15px; color: #6b7280; font-weight: 500"
              >Seller</span
            >
            <span style="font-size: 14px; color: #222; font-weight: 600">{{
              sellerName
            }}</span>
          </div>
        </a-col>
        <a-col :span="5">
          <div style="display: flex; flex-direction: column">
            <span style="font-size: 15px; color: #6b7280; font-weight: 500"
              >Expected Delivery</span
            >
            <span style="font-size: 14px; color: #222; font-weight: 600">{{
              formatDate(consignmentDetails.delvieryDate)
            }}</span>
          </div>
        </a-col>
        <a-col :span="5">
          <div style="display: flex; flex-direction: column">
            <span style="font-size: 15px; color: #6b7280; font-weight: 500"
              >Submission Date</span
            >
            <span style="font-size: 14px; color: #222; font-weight: 600">{{
              formatDate(consignmentDetails.createdAt)
            }}</span>
          </div>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="4">
          <div style="display: flex; flex-direction: column">
            <span style="font-size: 15px; color: #6b7280; font-weight: 500"
              >Warehouse Receiving</span
            >
            <span style="font-size: 14px; color: #222; font-weight: 600">{{
              consignmentDetails.warehouse || "N/A"
            }}</span>
          </div>
        </a-col>
        <!-- <a-col :span="4">
          <div style="display: flex; flex-direction: column">
            <span style="font-size: 15px; color: #6b7280; font-weight: 500"
              >Receiver Name</span
            >
            <span style="font-size: 14px; color: #222; font-weight: 600">{{
              consignmentDetails.receiverName || "N/A"
            }}</span>
          </div>
        </a-col> -->
        <a-col :span="4">
          <div style="display: flex; flex-direction: column">
            <span style="font-size: 15px; color: #6b7280; font-weight: 500"
              >Actual Receipt Date</span
            >
            <span style="font-size: 14px; color: #222; font-weight: 600">{{
              formatDate(consignmentDetails.createdAt)
            }}</span>
          </div>
        </a-col>
      </a-row>
    </a-card>

    <a-card title="Product Receipt Details" style="margin-top: 24px">
      <!-- Alert: Only show if more than 1 batch and not all received -->
      <a-alert
        v-if="showBatchAlert"
        type="warning"
        show-icon
        message="All batches must be marked as 'Received' before the consignment status will be updated to Delivered."
        style="margin-bottom: 16px;"
      />
      <!-- <div slot="extra">
        <a-button type="link" @click="viewBatchHistory" style="color: #26a246"
          >View Consignment Details</a-button
        >
      </div> -->
      <a-table
        :columns="productColumns"
        :data-source="consignmentDetails.batchOrders"
        :pagination="false"
        rowKey="id"
        :scroll="{ x: 'max-content' }"
        bordered
      >
        <template slot="expectedQuantity" slot-scope="text, record">
          {{ record.unitQuantity }} Units
        </template>
        <template slot="receivedQuantity" slot-scope="text, record">
          <span v-if="record.batchStatus === 'Received'">
            {{ record.receivedQuantity }} Units
          </span>
          <a-input
            v-else
            v-model="record.receivedQuantity"
            placeholder="Enter quantity"
            style="width: 120px"
            type="number"
            min="1"
          />
        </template>
        <template slot="batchStatus" slot-scope="text, record">
          <StatusTag :status="record.batchStatus" />
        </template>
        <template slot="status" slot-scope="text, record">
          <StatusTag :status="record.status" />
        </template>
        <template slot="actions" slot-scope="text, record">
          <StatusTag
            v-if="record.batchStatus === 'Received'"
            status="Marked as Received"
          />
          <a-button
            v-else
            :class="{
              'green-button': isEntireBatchReceived(record),
              'red-button': !isEntireBatchReceived(record),
            }"
            @click="markBatchStatus(record)"
            :disabled="!isValidReceivedQuantity(record.receivedQuantity) || loadingBatchId === record.id"
            :loading="loadingBatchId === record.id"
            icon="check"
          >
            {{
              Number(record.unitQuantity) === Number(record.receivedQuantity)
                ? "Received"
                : "Mismatched"
            }}
          </a-button>
        </template>
      </a-table>
      <!-- <div style="display: flex; justify-content: flex-end; align-items: flex-start; width: 100%; margin-top: 16px;">
        <div style="display: flex; align-items: center; gap: 12px;">
          <span style="font-size: 14px; color: #222; font-weight: 500;">Partial Receipt Mode</span>
          <a-switch v-model="partialReceiptMode" :checked-color="'#26a246'" />
        </div>
      </div> -->
    </a-card>

    <!-- <a-card title="Environmental Checks" style="margin-top: 24px;">
      <p>Temperature at Receipt (optional)</p>
      <a-input placeholder="e.g. 4-6°C" style="width: 200px;"></a-input>
    </a-card> -->

    <div class="footer-actions">
      <a-button
        @click="goBack"
        style="background-color: #26a246; color: white; border-color: #26a246"
        icon="arrow-left"
        >Back</a-button
      >
      <!-- <a-button type="primary" @click="confirmReceipt"  style="background-color: #26A246; color: white; border-color: #26A246;" icon="check">Confirm Receipt</a-button> -->
    </div>

    <!-- <a-modal
      v-model="showBatchHistoryModal"
      title="Batch History"
      width="700px"
      :footer="null"
      @cancel="showBatchHistoryModal = false"
    >
      <a-table
        :columns="[
          { title: 'Batch Number', dataIndex: 'batchNumber', key: 'batchNumber' },
          { title: 'Product Name', dataIndex: 'productName', key: 'productName' },
          { title: 'Status', dataIndex: 'status', key: 'status' },
          { title: 'Received Quantity', dataIndex: 'receivedQuantity', key: 'receivedQuantity' },
          { title: 'Updated At', dataIndex: 'updatedAt', key: 'updatedAt', customRender: (text) => formatDate(text) }
        ]"
        :data-source="consignmentDetails.batchOrders || []"
        :pagination="false"
        rowKey="batchNumber"
        :scroll="{ x: 'max-content' }"
        bordered
      />
    </a-modal> -->
  </div>
</template>

<script>
import sellersService from "@/api/sellers.service";
import StatusTag from "../../shared-components/StatusTag.vue";
import { mapGetters, mapActions } from "vuex";
import { formatDate } from "../../../utils";

export default {
  name: "ConsignmentDetails",
  components: { StatusTag },
  props: {
    userId: {
      type: String,
      required: true,
    },
    consignmentId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      consignmentDetails: {},
      partialReceiptMode: false,
      productColumns: [
        { title: "Batch Number", dataIndex: "batchNumber", key: "batchNumber" },
        { title: "Product Name", dataIndex: "productName", key: "productName" },
        {
          title: "Manufacture Date",
          key: "manufactureDate",
          customRender: (text, record) =>
            this.formatDate(record.manufactureDate),
        },
        {
          title: "Expiry Date",
          key: "expiryDate",
          customRender: (text, record) => this.formatDate(record.expiryDate),
        },
        {
          title: "Expected Quantity",
          dataIndex: "unitQuantity",
          key: "expectedQuantity",
          scopedSlots: { customRender: "expectedQuantity" },
        },
        {
          title: "Received Quantity",
          key: "receivedQuantity",
          scopedSlots: { customRender: "receivedQuantity" },
        },
        {
          title: "Actions",
          key: "actions",
          scopedSlots: { customRender: "actions" },
        },
        {
          title: "Status",
          key: "batchStatus",
          scopedSlots: { customRender: "batchStatus" },
        },
        {
          title: "Health Status",
          key: "status",
          scopedSlots: { customRender: "status" },
        },
      ],
      loadingBatchId: null,
    };
  },
  computed: {
    ...mapGetters("sellerManagement", ["seller"]),
    sellerName() {
      if (!this.seller) return "N/A";
      if (
        this.seller.businessDetails &&
        this.seller.businessDetails.businessName
      )
        return this.seller.businessDetails.businessName;
      return "N/A";
    },
    allBatchesReceived() {
      const batches = this.consignmentDetails.batchOrders || [];
      return (
        batches.length > 0 &&
        batches.every(
          (batch) => batch.status && batch.batchStatus.toLowerCase() === "received"
        )
      );
    },
    showBatchAlert() {
      const batches = this.consignmentDetails.batchOrders || [];
      return batches.length > 1 && !this.allBatchesReceived;
    },
  },
  watch: {
    consignmentId: {
      immediate: true,
      handler(newId) {
        if (newId) {
          this.fetchConsignmentDetails();
        }
      },
    },
  },
  mounted() {
    this.fetchSeller(this.userId);
  },
  methods: {
    ...mapActions("sellerManagement", ["fetchSeller"]),
    async fetchConsignmentDetails() {
      this.loading = true;
      const response = await sellersService.getConsignmentDetails(
        this.userId,
        this.consignmentId
      );
      console.log("consignment", response);
      if (response?.status === 200) {
        this.consignmentDetails = response?.data?.data || {};
      } else {
        this.consignmentDetails = {};
        this.$message.error("Failed to fetch consignment details");
      }
      this.loading = false;
    },
    formatDate,
    goBack() {
      this.$router.push(`/sellers/${this.userId}?tab=6&subTab=2`);
    },
    async markBatchStatus(record) {
      this.loadingBatchId = record.id;
      const status =
        Number(record.receivedQuantity) === Number(record.unitQuantity)
          ? "Received"
          : "Mismatched";
      const response = await sellersService.updateBatchStatus({
        batchId: record.id,
        consignmentOrderId: this.consignmentId,
        status,
        receivedQuantity: Number(record.receivedQuantity),
      });
      // console.log({
      //   batchId: record.id,
      //   consignmentOrderId: this.consignmentId,
      //   status,
      //   receivedQuantity: Number(record.receivedQuantity),
      // });
      console.log("batch update", response.data);
      if (response.data.code === 200) {
        this.$message.success("Batch status updated to " + status + "!");
        await this.fetchConsignmentDetails();
      } else {
        // record.status = oldStatus;
        this.$message.error(
          "Failed to update batch status: " +
            (response.data.message || "Unknown error.")
        );
      }
      this.loadingBatchId = null;
    },
    viewBatchHistory() {
      this.$router.push({
        name: "ConsignmentOrderDetails",
        params: {
          userId: this.userId,
          consignmentId: this.consignmentId,
        },
      });
    },
    isEntireBatchReceived(record) {
      return Number(record.unitQuantity) === Number(record.receivedQuantity);
    },
    isValidReceivedQuantity(value) {
      const num = Number(value);
      return Number.isInteger(num) && num > 0;
    },
  },
};
</script>

<style scoped>
.consignment-details-container {
  padding: 24px;
  background-color: #f0f2f5;
}

.consignment-header-card {
  margin-bottom: 24px;
}

.footer-actions {
  margin-top: 24px;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer-actions button {
  margin-left: 8px;
}

.green-button {
  background-color: #52c41a;
  border-color: #52c41a;
  color: #fff;
}

.red-button {
  background-color: #f5222d;
  border-color: #f5222d;
  color: #fff;
}

/* Custom style for Ant Design Vue switch if checked-color prop is not supported */
.ant-switch-checked {
  background-color: #26a246 !important;
}
</style>
